import React, { useState, useEffect } from 'react';
import { Box, Typography, Stack, FormControl, InputLabel, OutlinedInput } from '@mui/material';
import Grid from '@mui/material/Grid';
import SaveButton from '../Components/SaveButton';
import axios from 'axios';
import { APIURL } from '../../../config';

const Workflow = (props) => {
    const [wf_taskCreationDays, setWf_taskCreationDays] = useState(null);

    const handleSave = async () => {
        try {
            if (props.wf_taskCreationDays !== wf_taskCreationDays) {
                let settingsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 73 } })).data;

                if (settingsData.length > 0) {
                    let settingsPayload = {
                        settings_id: settingsData[0].settings_id, feature_value: wf_taskCreationDays, feature_id: 73,
                    }
                    let result = await axios.put(APIURL + `/config/settings`, { ...settingsPayload });
                } else {
                    let settingsPayload = {
                        feature_value: wf_taskCreationDays,
                        feature_id: 73,
                        company_id: props.comp_id,
                        added_by: props.user_id
                    }
                    let result = await axios.post(APIURL + `/config/settings`, { ...settingsPayload });
                }

                props.setWf_taskCreationDays(wf_taskCreationDays);
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        setWf_taskCreationDays(props.wf_taskCreationDays);
    }, [props.wf_taskCreationDays]);

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
                <Grid size={props.leftColumnSize}>
                    <Stack spacing={1}>
                        <Typography variant="h5">
                            Workflow Settings
                        </Typography>
                        <Typography variant="body1" sx={{ color: 'gray' }}>
                            Workflow related settings
                        </Typography>
                    </Stack>
                </Grid>
                <Grid size={props.rightColumnSize}>
                    <Stack spacing={3}>
                        <Box>
                            <Typography variant="h6">
                                Task created no. of days before the start date
                            </Typography>
                            <FormControl sx={{ marginTop: 1 }} size="small">
                                <InputLabel htmlFor="outlined-days">Days</InputLabel>
                                <OutlinedInput
                                    id="outlined-days"
                                    label="Days"
                                    type="number"
                                    inputProps={{ min: 0 }}
                                    value={wf_taskCreationDays}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === '' || /^\d+$/.test(value)) {
                                            setWf_taskCreationDays(value);
                                        }
                                    }}
                                />
                            </FormControl>
                        </Box>
                        <SaveButton onClick={handleSave} disabled={props.wf_taskCreationDays === wf_taskCreationDays} />
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    );
}

export default Workflow;